module.exports = __webpack_public_path__ + "static/media/BodyRelaxationTechniques.e187fda5.jpg";